export default "__VITE_ASSET__CToIqQ6c__"